
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"transparent","d":"M0 0h20v20H0z"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"8","fill":"#FFF2C7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.094 3.68A7.96 7.96 0 019 2.062v2.021a5.968 5.968 0 00-2.477 1.026L5.094 3.68zM16 10a6.002 6.002 0 00-5-5.917V2.062A8.001 8.001 0 0110 18a8.001 8.001 0 01-7.938-7h2.021A6.002 6.002 0 0016 10zM4.083 9a5.968 5.968 0 011.026-2.477L3.68 5.094A7.96 7.96 0 002.062 9h2.021zM11 6a1 1 0 10-2 0v4a1 1 0 00.293.707l2.5 2.5a1 1 0 001.414-1.414L11 9.586V6z","fill":"#B0661C"}})])
          )
        }
      }
    